module.exports = __webpack_public_path__ + "static/img/ubnKSIfAJTxIgXOKlciN.75ede09e.png";